'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function PackageSearchForm() {
  const router = useRouter();
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [departDate, setDepartDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [travelers, setTravelers] = useState(2);
  const [packageType, setPackageType] = useState<'flight+hotel' | 'flight+hotel+car'>('flight+hotel');

  const handleSearch = () => {
    // BACKEND: POST /api/search/packages with { origin, destination, departDate, returnDate, travelers, packageType }
    router.push('/search-results-page');
  };

  return (
    <div className="space-y-4">
      {/* Package Type Toggle */}
      <div className="flex items-center gap-2">
        {[
          { id: 'flight+hotel', label: '✈ + 🏨 Flight + Hotel' },
          { id: 'flight+hotel+car', label: '✈ + 🏨 + 🚗 + Car' },
        ].map((type) => (
          <button
            key={`pkg-${type.id}`}
            type="button"
            onClick={() => setPackageType(type.id as any)}
            className={`px-4 py-2 rounded-lg text-xs font-semibold transition-all duration-150 ${
              packageType === type.id
                ? 'bg-accent text-white' :'bg-muted text-muted-foreground hover:text-foreground'
            }`}
          >
            {type.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Flying from</label>
          <div className="relative">
            <Icon name="PaperAirplaneIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-primary pointer-events-none" />
            <input
              type="text"
              value={origin}
              onChange={(e) => setOrigin(e.target.value)}
              placeholder="Origin city"
              className="input-base w-full pl-9 pr-3 py-3 text-sm"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Going to</label>
          <div className="relative">
            <Icon name="MapPinIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-accent pointer-events-none" />
            <input
              type="text"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              placeholder="Destination"
              className="input-base w-full pl-9 pr-3 py-3 text-sm"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Depart — Return</label>
          <div className="flex items-center gap-1">
            <input
              type="date"
              value={departDate}
              onChange={(e) => setDepartDate(e.target.value)}
              className="input-base w-full px-2 py-3 text-sm"
            />
            <span className="text-muted-foreground text-xs">→</span>
            <input
              type="date"
              value={returnDate}
              onChange={(e) => setReturnDate(e.target.value)}
              className="input-base w-full px-2 py-3 text-sm"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-600 text-muted-foreground mb-1">Travelers</label>
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <Icon name="UserGroupIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
              <input
                type="number"
                min={1}
                max={9}
                value={travelers}
                onChange={(e) => setTravelers(Number(e.target.value))}
                className="input-base w-full pl-9 pr-3 py-3 text-sm"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={handleSearch}
          className="btn-accent px-8 py-3 text-sm flex items-center gap-2"
        >
          <Icon name="MagnifyingGlassIcon" size={18} />
          Find Packages
        </button>
      </div>
    </div>
  );
}